<template>
  <div class="container-fluid h-100">
    <div class="row">
      <div class="col-12">
        <h1 class="h4 mt-1">Relatórios</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-3 pt-2 d-flex align-items-stretch justify-content-stretch" v-for="{Titulo, Caminho} in DadosRelatorios.Relatorios" :key="Titulo">
        <div class="card w-100 cursor-pointer" v-on:click="abrirRelatorioSelecionado(Caminho)">
          <div class="card text-center h-100 w-100">
            <div class="card-body">
              <div class="row">
                <div class="col-12">
                  <i class="fas fa-book icone-lmx-book"></i>
                </div>
              </div>
              <div class="row h-75 d-flex d-flex align-items-center">
                <div class="col-12">
                  {{Titulo}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .icone-lmx-book {
    font-size: 2.5rem;
    color: #5b2e90;
  }
</style>

<script>
import LMA from "../assets/Microservices/LMAClient.superagent";
import routes from "../assets/Microservices/Routes/BIRoutes";
import loading from '../assets/js/loading/'
import swal from '../assets/js/alerts/'
import store from '../store';

export default {
  name: "TelaRelatorios",
  props: [],
  data() {
    return {
      DadosRelatorios: []
    };
  },

  mounted: function() {
    this.buscarDadosIniciais();
  },

  methods: {
    buscarDadosIniciais: function() {
      var self = this;

      loading.exibir();

      LMA.get(routes.BI.ObterDadosIniciaisRelatorios, function(response) {
        self.DadosRelatorios = JSON.parse(response);
        loading.ocultar();
      }, swal.exibirMensagemValidacaoApi, swal.exibirMensagemErroApi);
    },

    abrirRelatorioSelecionado: function(caminho) {
      var self = this;
      
      var f = document.createElement("form");
      f.setAttribute('method',"post");
      f.setAttribute('action', process.env.VUE_APP_URL_BI_API + "Reports.aspx");
      f.setAttribute('target',"_blank");

      var i_caminhoRelatorio = document.createElement("input"); //input element, text
      i_caminhoRelatorio.setAttribute('type',"text");
      i_caminhoRelatorio.setAttribute('name',"caminho_relatorio");
      i_caminhoRelatorio.setAttribute('hidden',"true");
      i_caminhoRelatorio.setAttribute('value', caminho);

      var i_JWTToken = document.createElement("input"); //input element, text
      i_JWTToken.setAttribute('type',"text");
      i_JWTToken.setAttribute('name',"JWToken");
      i_JWTToken.setAttribute('hidden',"true");
      i_JWTToken.setAttribute('value', store.getters.getInfoUsuario().JWT);

      var s = document.createElement("input"); //input element, Submit button
      s.setAttribute('type',"submit");
      s.setAttribute('value',"Submit");

      f.appendChild(i_JWTToken);
      f.appendChild(i_caminhoRelatorio);
      f.appendChild(s);

      document.getElementsByTagName('body')[0].appendChild(f);

      f.submit();
    }
  }
};
</script>